import { makeReducer } from '../core/make-reducer';
import { makeActionCreators } from '../core/make-action-creators';
import * as API from '../core/api';

export const actions = {
  REQUEST: 'Dora/invite/REQUEST',
  RECEIVE: 'Dora/invite/SUCCESS',
  FAIL: 'Dora/invite/FAIL',
};

export default makeReducer({
  actions,
});

const actionCreators = makeActionCreators({
  reducerName: 'invite',
  actions,
  requestDataCall: (store, inviteId) => API.get(`invites/${inviteId}`),
});

export const requestDataIfNeeded = actionCreators.requestDataIfNeeded;



// WEBPACK FOOTER //
// ./src/invite/duck.js